import moment from 'moment-timezone';

export const isDateInPast = (date: Date | string, timezone?: string): boolean => {
  const now = timezone ? moment.tz(timezone) : moment();
  return moment(date).isBefore(now, 'day');
};

export const isDateBeforeReference = (
  date: Date | string,
  referenceDate?: Date | string | null,
  hasExistingRecord?: boolean,
): boolean => {
  if (!referenceDate) return true;
  if (hasExistingRecord) return true;
  return moment(date).isBefore(referenceDate, 'day');
};
